/**
 * Copyright (c) 2021
 *
 * Functions available of the Javacript SDK for Gift Card Pro. To be included and made available in the
 * storefront javascript file
 *
 * @summary Gift Card Pro Javacript SDK
 * @author Zac Fair <zac@gist-apps.com>
 *
 * Created at     : 2021-10-22 3:04:00
 * Last modified  : 2021-10-22 3:04:00
 */


/**
 * Set the sdk data whenever new data is needed.
 *
 * @return {Object} GCP.SDKDATA
 */
export const setSdkData = (parameter, data) => {

  if (typeof(GCP) === 'undefined') {
    window.GCP = {};
  }

  if (typeof(GCP.SDKDATA) == 'undefined') {
    GCP.SDKDATA = {};
  }

  GCP.SDKDATA[parameter] = data;

  if (typeof(GCP.SDKDATA[parameter].pricing_plan_id) != 'undefined' ) {
    delete GCP.SDKDATA[parameter].pricing_plan_id;
  }

}

/**
 * Public facing SDK functions
 *
 * @return {Object} window.GCPSDK
 */
export const sdkFunctions = (() => {


  /**
   * Return the current order data
   *
   * @var {json}
   */
  const getSettings = () => {

    if (typeof(GCP) == 'undefined' || typeof(GCP.SDKDATA) == 'undefined' || typeof(GCP.SDKDATA.settings) == 'undefined') {
      return {
        error: true,
        message: "Current Gift Card Pro settings data is not available. Please see https://docs.giftcardpro.app for more details."
      }
    }

    return GCP.SDKDATA.settings;

  }


  /**
   * Get information about the current page.
   *
   * @var {Object}
   */
  const getPage = () => {

    if (typeof(GCP.SDKDATA.page) == 'undefined') {
      return {
        error: true,
        message: "Current page data is not available. Please see https://docs.giftcardpro.app for more details."
      }
    }

    return GCP.SDKDATA.page;

  };

  /**
   * Get the current form details.
   *
   * @var {Object}
   */
  const getForm = () => {

    if (typeof(GCP.SDKDATA.form) == 'undefined') {
      return {
        error: true,
        message: "Current form data is not available. Please see https://docs.giftcardpro.app for more details."
      }
    }

    return GCP.SDKDATA.form;

  };


  /**
   * builld
   *
   * @const {Object}
   */
  const sdk = {
    page: {
      get: getPage
    },
    settings: {
      get: getSettings,
    },
    form: {
      get: getForm,
      set: null
    }
  };

  /**
   * Register the GCPSDK object with the window
   *
   * @var {Object} window.GCPSDK
   */
  if (typeof(window.GCPSDK) == 'undefined') {
    window.GCPSDK = sdk;
  } else {
    window.GCPSDK = { ...window.GCPSDK, ...sdk };
  }

  return sdk;

})();
